// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__3O9kk","dense":"styles_dense__2zrtl","tab_item":"styles_tab_item__1I6l3","tab_scroller":"styles_tab_scroller__2jHug","selected":"styles_selected__1gODm"};